/* ORGANO/TYGRON — Framer Motion (vanilla `motion`) enhancement layer (v1, 2026-05-30)
   Uses window.Motion from the vendored UMD build (assets/motion.min.js). This is the
   same animation engine as Framer Motion, without React — the correct way to ship
   Framer-style motion on a Liquid theme.

   Additive over the glass layer and fully reversible. When active it OWNS the
   scroll-reveal (spring physics + per-element stagger); redesign-glass.js cedes to it
   and stays as the no-dependency floor. A head-inline watchdog restores that floor if
   this script (or the lib) never boots, so the page can never be left with hidden
   content. Reduced-motion is honoured (no JS-driven motion). Copy is never touched. */
(function () {
  "use strict";

  var M = window.Motion;
  // Lib missing/failed to parse → do nothing and DON'T flag ready; the head
  // watchdog will run the CSS/IO floor reveal instead.
  if (!M || !M.animate) return;

  // Lib is present — tell the watchdog motion is alive so it won't force the floor.
  window.__rgMotionReady = true;

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) return; // floor already revealed everything instantly for reduced-motion

  var animate = M.animate, inView = M.inView;

  // ── A. Spring scroll-reveal (overshoot + stagger) ──────────────────────────
  // Nodes were collected + hidden (.rg-reveal) by redesign-glass.js. The CSS
  // (html.rg-motion .rg-reveal) drops its transition + blur so the spring runs clean.
  var nodes = window.__rgNodes || [];
  nodes.forEach(function (node) {
    var iv = node.style.getPropertyValue("--rg-i"); // set on stat-grid cards → stagger
    var delay = iv ? parseFloat(iv) * 0.07 : 0;
    inView(node, function () {
      animate(
        node,
        { opacity: [0, 1], transform: ["translateY(38px)", "translateY(0px)"] },
        { type: "spring", stiffness: 120, damping: 20, mass: 1, delay: delay }
      );
    }, { amount: 0.12, margin: "0px 0px -8% 0px" });
  });

  // ── B. Scroll-progress bar (own element → no theme-CSS conflict) ────────────
  // A reading-progress indicator: the bar's scaleX tracks page scroll. Driven by a
  // small rAF-throttled handler (reliable across browsers) rather than a scrubbed
  // animation, so it always reflects the true scroll position.
  try {
    var bar = document.createElement("div");
    bar.className = "rg-progress";
    document.body.appendChild(bar);
    var ticking = false;
    function paint() {
      ticking = false;
      var max = (document.documentElement.scrollHeight || document.body.scrollHeight) - window.innerHeight;
      var p = max > 0 ? Math.min(1, Math.max(0, window.pageYOffset / max)) : 0;
      bar.style.transform = "scaleX(" + p + ")";
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    }, { passive: true });
    window.addEventListener("resize", paint, { passive: true });
    paint();
  } catch (e) { /* progress bar is optional; ignore */ }

  /* Note: a pointer "magnetic" hover was prototyped for the primary CTAs but the
     theme already sets `transform … !important` on those buttons (they have their
     own CSS hover transition), so any JS transform is overridden. Left out rather
     than ship dead code or fight the existing button styling. The buttons keep
     their glass gradient + sheen hover from redesign-glass.css. */
})();
